import _ from "underscore"
import BaseTableDataConverter from "../table/BaseTableDataConverter";
import LeavesReportUtils from "./LeavesReportUtils";
import {RowType} from "../table/RowType";

export default class TableDataConverter extends BaseTableDataConverter {
    constructor(reportData, reportParams) {
        super(reportData, reportParams);
        this.hasPto = LeavesReportUtils.reportParamsWithPTO(this.reportParams);
        this.hasSick = LeavesReportUtils.reportParamsWithSick(this.reportParams);
    }

    _createHeader() {
        return {
            type: RowType.HEADER,
            leaveTypeIds: _.pluck(this.reportData["leaveSpent"], "leaveTypeId"),
            // TODO: aT and aP have different format of dates from some reason
            balancesRange: {startDate: this.reportParams.dateRangeSelection.fromDate, endDate: this.reportParams.dateRangeSelection.toDate},
            hasPto: this.hasPto,
            hasSick: this.hasSick
        }
    }

    _createDataRow(level, type, groupingType, leavesReportItem) {
        const dataRow = {
            id: leavesReportItem["id"],
            type: type,
            total: leavesReportItem["totalLeaveSpent"],
            leaveTypeTotals: _.pluck(leavesReportItem["leaveSpent"], "leaveSpent")
        };

        const date = leavesReportItem["date"];
        const dateRange = leavesReportItem["dateRange"];
        const ptoBalance = leavesReportItem["ptoBalance"];
        const sickBalance = leavesReportItem["sickBalance"];

        if (this.hasPto)
            dataRow.ptoBalances = {
                start: ptoBalance ? ptoBalance["balanceForFirstColumn"] : null,
                end: ptoBalance ? ptoBalance["balanceForSecondColumn"] : null
            };
        if (this.hasSick)
            dataRow.sickBalances = {
                start: sickBalance ? sickBalance["balanceForFirstColumn"] : null,
                end: sickBalance ? sickBalance["balanceForSecondColumn"] : null
            };

        return dataRow;
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/leavesReport/TableDataConverter.js